<div class="signup-questions-container">
	<div class="signup-questions-content">
				<nz-steps [nzCurrent]="currentStep" nzSize="small">
      <nz-step nzTitle="Your roles and experience" />
      <nz-step nzTitle="Salary and Work preferences" />
      <nz-step nzTitle="Get to know you" />
			<nz-step nzTitle="Review" />
    </nz-steps>
		<div class="steps-content">
			@switch (currentStep) {
				@case (0) {
					<app-first-step />
				}
				@case (1) {
					<app-second-step />
				}
				@case (2) {
					<app-third-step />
				}
				@case (3) {
					<app-fourth-step />
				}
			}
		</div>
	</div>
</div>
<div class="steps-action">
	@if (currentStep > 0) {
		<button nz-button nzType="default" class="GA-onboarding-prev-btn" (click)="pre()">
			<span>Back</span>
		</button>
	}@else{
		<button nz-button nzType="default" class="GA-onboarding-cancel-btn" (click)="cancel()">
			<span>Cancel</span>
		</button>
	}

	@if (currentStep < 3) {
		<div class="btn-next-group" style="margin-left: auto;">
			<button nz-button nzType="default" class="GA-onboarding-skip-btn" (click)="skip()">
				<span>Do this later</span>
			</button>
			<button [disabled]="!isButtonEnabled" nz-button nzType="primary" class="GA-onboarding-next-btn" (click)="next()">
				<span>Next</span>
			</button>
		</div>

	}
	@if (currentStep === 3) {
		<button style="margin-left: auto;" nz-button nzType="primary" class="GA-onboarding-done-btn" (click)="done()">
			<span>Done</span>
		</button>
	}
</div>

<!-- Flexible Salary Modal -->
<nz-modal
	[(nzVisible)]="isFlexibleSalaryModalVisible"
	[nzContent]="flexibleSalaryModalContent"
	[nzFooter]="null"
	[nzClosable]="true"
	[nzMaskClosable]="false"
	(nzOnCancel)="onFlexibleSalaryModalContinue()"
	nzCentered
	nzWidth="600px"
>
	<ng-template #flexibleSalaryModalContent>
		<img src="../../assets/images/did-you-know.svg" alt="Flexible Salary Tip" class="flexible-salary-modal-image" />
		<h2 class="flexible-salary-modal-title">Did you know</h2>
		<p class="flexible-salary-modal-content">Being flexible with your salary range can help unlock more job matches.</p>
		<div class="flexible-salary-modal-footer">
			<button nz-button nzType="primary" (click)="onFlexibleSalaryModalCancel()">Update salary</button>
			<button nz-button nzType="default" (click)="onFlexibleSalaryModalContinue()">Maybe later</button>
		</div>
	</ng-template>
</nz-modal>